
export const formConstants = {
    verificationCode: 'verificationCode',
    website: 'website',
    ssoDomain: 'ssoDomain',
    membership: 'membership',
    emailAddress: 'emailAddress',
    email: 'email',
    confirmEmailAddress: 'confirmEmailAddress',
    username: 'username',
    password: 'password',
    confirmPassword: 'confirmPassword',
    oldPassword: 'oldPassword',
    title: 'title',
    titlePropertyForValue: 'code',
    firstName: 'firstName',
    lastName: 'lastName',
    dateOfBirth: 'dateOfBirth',
    noAddressFoundText: 'noAddressFoundText',
    addresses: 'addresses',
    addressLine1: 'addressLine1',
    addressLine2: 'addressLine2',
    addressLine3: 'addressLine3',
    postcode: 'postcode',
    mobilePhone: 'mobilePhone',
    countryCodeMobilePhonePrefix: 'countryCodeMobilePhonePrefix',
    city: 'city',
    country: 'country',
    countryName: 'countryName',
    countyName: 'countyName',
    stateName: 'stateName',
    countryPropertyForValue: 'code',
    county: 'county',
    state: 'state',
    mainAddress: 'mainAddress',
    mainAddressLabel: 'mainAddressLabel',
    main: 'main',
    shippingAddress: 'shippingAddress',
    billingAddress: 'billingAddress',
    countyPropertyForValue: 'title',
    statePropertyForValue: 'code',
    interests: 'interests',
    joinTheOneClubInputLabelText: 'joinTheOneClubInputLabelText',
    becomeOneClubMember: 'becomeOneClubMember',
    becomeOneClubMemberInfo: 'becomeOneClubMemberInfo',
    hasTicketingAccount: 'hasTicketingAccount',
    hasOneClubAccount: 'hasOneClubAccount',
    favoritePlayer: 'favoritePlayer',
    venues: 'venues',
    optIns: 'optIns',
    offersDetails: 'offersDetails',
    refuseOffers: 'refuseOffers',
    acceptOffers: 'acceptOffers',
    privacyPolicy: 'privacyPolicy',
    oneClubTermsAndServices: 'oneClubTermsAndServices',
    termsOfService: 'termsOfService',
    actionSuccessText: 'actionSuccessText',
    emailChangedConflictMessage: 'emailChangedConflictMessage',
    joinTheOneClubActionSuccessText: 'joinTheOneClubActionSuccessText',
    leaveTheOneClubActionSuccessText: 'leaveTheOneClubActionSuccessText',
    updateDetailsActionSuccessText: 'updateDetailsActionSuccessText',
    theOneClubImageSource: 'theOneClubImageSource',
    theOneClubImageText: 'theOneClubImageText',
    theOneClubVideoText: 'theOneClubVideoText',
    theOneClubThumbnailSource: 'theOneClubThumbnailSource',
    theOneClubVideoWebmSource: 'theOneClubVideoWebmSource',
    theOneClubVideoSource: 'theOneClubVideoSource',
    theOneClubMotivationTitle: 'theOneClubMotivationTitle',
    theOneClubMotivationImageSource: 'theOneClubMotivationImageSource',
    theOneClubReasons: 'theOneClubReasons',
    theOneClubFAQTitle: 'theOneClubFAQTitle',
    theOneClubFAQs: 'theOneClubFAQs',
    leaveTheOneClubDialogBoxTitle: 'leaveTheOneClubDialogBoxTitle',
    leaveTheOneClubDialogBoxMessage: 'leaveTheOneClubDialogBoxMessage',
    leaveTheOneClubDialogBoxAgreeButton: 'leaveTheOneClubDialogBoxAgreeButton',
    leaveOneClubDialogBoxCheckText: 'leaveOneClubDialogBoxCheckText',
    dotDigitalAddressBookData: 'dotDigitalAddressBookData',
    saveUserToDotDigitalCallbackUrl: 'saveUserToDotDigitalCallbackUrl',
    maxIdleTimeInSeconds: 'maxIdleTimeInSeconds',
    userData: 'userData',
    activeMemberships: 'activeMemberships',
    formTitle: 'formTitle',
    introText: 'introText',
    formSubTitle: 'formSubTitle',
    callBackUrl: 'callBackUrl',
    removeAccountCallbackUrl: 'removeAccountCallbackUrl',
    addAddress: 'addAddress',
    updateAddress: 'updateAddress',
    cannotRemoveLastAddressMessage: 'cannotRemoveLastAddressMessage',
    cannotRemoveMainAddressMessage: 'cannotRemoveMainAddressMessage',
    cannotRemoveShippingAddressMessage: 'cannotRemoveShippingAddressMessage',
    cannotRemoveBillingAddressMessage: 'cannotRemoveBillingAddressMessage',
    noOrdersFoundText: 'noOrdersFoundText',
    noProductsFoundText: 'noProductsFoundText',
    noPaymentSummaryFoundText: 'noPaymentSummaryFoundText',
    noDeliveryDataFoundText: 'noDeliveryDataFoundText',
    noHistoryDataFoundText: 'noHistoryDataFoundText',
    masterCardDialogBox: 'masterCardDialogBox',
    masterCardDialogBoxBanner: 'masterCardDialogBoxBanner',
    showDialogBox: 'showDialogBox',
    noActionsToPerformText: 'noActionsToPerformText',
    secuTixErrorMessage: 'secuTixErrorMessage',
    loadingErrorMessage: 'loadingErrorMessage',
    elapsedTimeLimit: 'elapsedTimeLimit',
    serverErrorMessage: 'serverErrorMessage',
    noUpcomingEventText: 'noUpcomingEventText',
    fileState: 'fileState',
    orderState: 'orderState',
    paymentStatus: 'paymentStatus',
    actionOrderType: 'actionOrderType',
    orderType: 'orderType',
    getHomePageTicketsDataCallbackUrl: 'getHomePageTicketsDataCallbackUrl',
    getOrderHistoryCallbackUrl: 'getOrderHistoryCallbackUrl',
    getOrderHistoryPagesCallbackUrl: 'getOrderHistoryPagesCallbackUrl',
    getOrderDetailsCallbackUrl: 'getOrderDetailsCallbackUrl',
    downloadDocumentPdfCallbackUrl: 'downloadDocumentPdfCallbackUrl',
    downloadFileSummaryPdfCallbackUrl: 'downloadFileSummaryPdfCallbackUrl',
    resumePaymentCallbackUrl: 'resumePaymentCallbackUrl',
    secutixAuthUrl: 'secutixAuthUrl',
    removeAccountInputText: 'removeAccountInputText',
    removeAccountInputWarning: 'removeAccountInputWarning',
    removeAccountModalWarning: 'removeAccountModalWarning',
    getTicketsCallbackUrl: 'getTicketsCallbackUrl',
    downloadTicketPdfCallbackUrl: 'downloadTicketPdfCallbackUrl',
    noTicketsFoundText: 'noTicketsFoundText',
    printTicketModalText: 'printTicketModalText',
    printTicketDialogText: 'printTicketDialogText',
    printTicketInputText: 'printTicketInputText',
    ticketIsPrintableText: 'ticketIsPrintableText',
    ticketIsNotPrintableText: 'ticketIsNotPrintableText',
    ticketIsAlreadyPrintedText: 'ticketIsAlreadyPrintedText',
    updatedNotificationSuccessMessage: 'updatedNotificationSuccessMessage',
    championshipSection: 'championshipSection',
    channelSection: 'channelSection',
    interestSection: 'interestSection',
    SecutixReservationStatus: 'IN_RESERVATION',
    SecutixReservationOrderType: 'RESERVATION',
    SecutixReservationRunningStatus: 'RUNNING',
    hostedUISignInReturnUrlSessionItemName: 'CognitoHostedUISignInReturnUrl',
    hostedUISignOutReturnUrlSessionItemName: 'CognitoHostedUISignOutReturnUrl',
    defaultValuePropertyName: 'defaultValue',
    showExpiryDate: 'showExpiryDate',
    ballotSignInStorageItem: 'ballotSignInData',
    isBallotRegister: 'isBallotRegister',
    showCancelButton: 'showCancelButton',
    showParkingButton: 'showParkingButton',
    showParkingButtonText: 'showParkingButtonText',
    parkingButtonUrl: 'parkingButtonUrl',
    reCaptcha: 'reCaptcha',
    reCaptchaCallbackUrl: 'reCaptchaCallBackURL',
    resaleTicketsTitle: 'resaleTicketsTitle',
    displayResaleCriteria: 'displayResaleCriteria',
    resaleTicketsInformation: 'resaleTicketsInformation',
    buyLink: 'buyLink',
    sellLink: 'sellLink',
    sellButtonCriteria: 'sellButtonCriteria',
    buyButtonCriteria: 'buyButtonCriteria',
    secutixResaleUrl: 'secutixResaleUrl',
    secutixPointOfSaleId: 'secutixPointOfSaleId',
    secutixVirtualOperator: 'secutixVirtualOperator',
    resaleTicketsImageSource: 'resaleTicketsImageSource',
    resaleTicketsImageText: 'resaleTicketsImageText',
    resaleTicketsFAQTitle: 'resaleTicketsFAQTitle',
    resaleTicketsFAQs: 'resaleTicketsFAQs',
    resaleTicketsIntro: 'resaleTicketsIntro',
    mastercard: 'mastercard',
    removeAddressInputText: 'removeAddressInputText',
    removeAddressModalWarning: 'removeAddressModalWarning',
    formType: 'formType',
    registerFormData: 'registerFormData'
};
